/**
 * 运营系统 - 任务管理
 */
<template>
  <div class="oms-task-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/taskList' }">运营系统</el-breadcrumb-item>
      <el-breadcrumb-item>任务管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="任务ID">
          <el-input
            v-model="formInline.taskId"
            placeholder="请输入任务ID"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务名称">
          <el-input
            v-model="formInline.taskName"
            placeholder="请输入任务名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="formInline.checkStatus"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核中" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
            <el-option label="驳回" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="createDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            clearable
            class="search-date-picker"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 任务列表 -->
    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
        border
      >
        <el-table-column
          fixed
          prop="taskId"
          label="任务ID"
          show-overflow-tooltip
          min-width="120"
        >
          <template #default="scope">
            <span @dblclick="copyToClipboard(scope.row.taskId)">{{ scope.row.taskId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="taskName"
          label="任务名称"
          show-overflow-tooltip
          min-width="150"
        >
          <template #default="scope">
            <span @dblclick="copyToClipboard(scope.row.taskName)">{{ scope.row.taskName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户名称"
          show-overflow-tooltip
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="distributeCompanyName"
          label="服务商名称"
          show-overflow-tooltip
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="taskTypeStr"
          label="任务类型"
          show-overflow-tooltip
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="checkStatus"
          label="审核状态"
          show-overflow-tooltip
          min-width="120"
        >
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.checkStatus)">
              {{ getStatusLabel(scope.row.checkStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="invoiceCategoryDesc"
          label="开票类目"
          show-overflow-tooltip
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="用工周期"
          show-overflow-tooltip
          min-width="120"
        >
          <template #default="scope">
            {{ scope.row.startTime }} - {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          label="计费范围"
          show-overflow-tooltip
          min-width="120"
        >
          <template #default="scope">
            {{
              scope.row.minCharge &&
              scope.row.maxCharge &&
              scope.row.unitStr
                ? scope.row.minCharge +
                  " - " +
                  scope.row.maxCharge +
                  "元/" +
                  scope.row.unitStr
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="年龄要求"
          show-overflow-tooltip
          min-width="120"
        >
          <template #default="scope">
            {{ scope.row.minAge }} - {{ scope.row.maxAge }}岁
          </template>
        </el-table-column>
        <el-table-column
          prop="location"
          label="服务地点"
          show-overflow-tooltip
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="createdAt"
          label="发布时间"
          show-overflow-tooltip
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="上线状态"
          show-overflow-tooltip
          min-width="120"
        >
          <template #default="scope">
            <span :style="{ color: scope.row.status === 1 ? '#67C23A' : '#F56C6C' }">
              {{ scope.row.status === 1 ? '上线' : '下线' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="附件"
          show-overflow-tooltip
          min-width="160"
        >
          <template #default="scope">
            <el-link type="primary" @click="openAttachmentDialog(scope.row, 'view')" style="margin-right: 3px;">查看</el-link>
            <el-link type="primary" @click="openAttachmentDialog(scope.row, 'upload')">上传</el-link>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="240"
          align="center"
          class-name="op-col"
        >
          <template #default="scope">
            <el-button
              size="mini"
              type="warning"
              @click="openEditDialog(scope.row)"
            >
              修改
            </el-button>
            <el-button
              size="mini"
              type="success"
              @click="approveTask(scope.row)"
            >
              通过
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="rejectTask(scope.row)"
            >
              驳回
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </el-card>

    <!-- 附件管理弹窗 -->
    <el-dialog
      :title="attachmentDialog.title"
      :visible.sync="attachmentDialog.visible"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="attachment-dialog" style="max-height: 450px; overflow-y: auto;">
        <!-- 查看模式 -->
        <template v-if="attachmentMode === 'view'">
          <!-- 文件列表 -->
          <div v-if="attachmentList.length > 0">
            <el-table
              :data="attachmentList"
              size="small"
              style="width: 100%;"
              :border="false"
              :striped="true"
              class="attachment-table"
            >
              <el-table-column
                prop="fileName"
                label="文件名"
                show-overflow-tooltip
                min-width="200"
              />
              <el-table-column
                label="大小"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  {{ formatFileSize(scope.row.fileSize) }}
                </template>
              </el-table-column>
              <el-table-column
                label="上传时间"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  {{ formatDateTime(scope.row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column
                label="预览"
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <!-- 图片显示缩略图 -->
                  <div 
                    v-if="isImage(scope.row)" 
                    class="attachment-preview"
                    @click="previewAttachment(scope.row)"
                  >
                    <img 
                      :src="scope.row.fileUrl" 
                      :alt="scope.row.fileName"
                      class="attachment-thumbnail"
                    />
                  </div>
                  <!-- 视频显示视频图标 -->
                  <el-link 
                    v-else-if="isVideo(scope.row)" 
                    type="primary" 
                    size="small" 
                    @click="previewAttachment(scope.row)"
                  >
                    <i class="el-icon-video-play"></i>
                  </el-link>
                  <!-- 其他文件显示- -->
                  <span v-else style="color: #C0C4CC;">-</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-link type="primary" size="small" @click="downloadAttachment(scope.row)" style="margin-right: 12px;">下载</el-link>
                  <el-link type="danger" size="small" @click="deleteAttachment(scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else style="text-align: center; padding: 40px 0; color: #909399;">
            <i class="el-icon-folder-opened" style="font-size: 48px; margin-bottom: 16px; display: block; color: #C0C4CC;"></i>
            <p style="font-size: 14px;">暂无附件</p>
          </div>
        </template>

        <!-- 上传模式 -->
        <template v-else>
          <!-- 文件上传区域（支持拖拽） -->
          <div style="padding: 20px 0; display: flex; justify-content: center;">
            <el-upload
              class="upload-demo"
              ref="attachmentUpload"
              :action="attachmentUploadUrl"
              :data="{ taskId: attachmentTaskId }"
              :file-list="attachmentFileList"
              :auto-upload="false"
              :on-change="handleAttachmentChange"
              :on-remove="handleAttachmentRemove"
              :limit="10"
              :on-exceed="handleAttachmentExceed"
              multiple
              drag
            >
              <i class="el-icon-upload" style="font-size: 48px; color: #8c8c8c;"></i>
              <div class="el-upload__text">
                拖拽文件到此处上传，或<em>点击选择文件</em>
              </div>
              <div class="el-upload__tip" style="color: #909399;">
                支持上传多种格式文件，单次最多上传10个文件
              </div>
            </el-upload>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAttachmentDialog">取消</el-button>
        <el-button
          v-if="attachmentMode === 'upload'"
          size="small"
          type="primary"
          :loading="attachmentUploading"
          @click="submitAttachmentUpload"
          >上传</el-button
        >
      </div>
    </el-dialog>

    <!-- 附件预览弹窗 -->
    <el-dialog
      :title="previewDialog.fileName"
      :visible.sync="previewDialog.visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div style="text-align: center;">
        <!-- 图片预览 -->
        <img
          v-if="previewDialog.isImage"
          :src="previewDialog.url"
          :alt="previewDialog.fileName"
          style="max-width: 100%; max-height: 500px; object-fit: contain;"
        />
        <!-- 视频预览 -->
        <video
          v-else
          :src="previewDialog.url"
          controls
          style="max-width: 100%; max-height: 500px;"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>

    <!-- 修改任务弹窗 -->
    <el-dialog
      title="修改任务"
      :visible.sync="editDialog.visible"
      width="820px"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="110px"
        :model="editForm"
        :rules="editRules"
        ref="editForm"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商户名称">
              <el-input :value="editForm.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务商名称">
              <el-input :value="editForm.distributeCompanyName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="任务名称" prop="taskName">
          <el-input v-model="editForm.taskName" placeholder="请输入任务名称" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="taskType">
          <el-select v-model="editForm.taskType" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="(val, index) in tasktype_list"
              :label="val.name"
              :value="val.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" prop="checkStatus">
          <el-select v-model="editForm.checkStatus" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="(val, index) in checkStatus_list"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票类目" prop="invoiceCategory">
          <el-cascader
            v-model="selectedCategories"
            :options="categoriesOptions"
            :props="{ expandTrigger: 'hover' }"
            @change="handleInvoiceCategoryChange"
            :show-all-levels="false"
            placeholder="请选择开票类目"
            filterable
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="用工周期" prop="date">
          <el-date-picker
            v-model="editForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="计费范围" prop="minCharge">
          <div style="display: flex; align-items: center; gap: 8px;">
            <el-input v-model="editForm.minCharge" placeholder="最低计费" style="flex: 1"></el-input>
            <span style="flex-shrink: 0">~</span>
            <el-input v-model="editForm.maxCharge" placeholder="最高计费" style="flex: 1"></el-input>
            <span style="flex-shrink: 0">元 /</span>
            <el-select v-model="editForm.unit" placeholder="单位" style="flex: 1">
              <el-option
                v-for="(val, index) in unit_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="年龄要求" prop="minAge">
          <div style="display: flex; align-items: center; gap: 8px;">
            <el-input v-model="editForm.minAge" placeholder="最小年龄" style="flex: 1"></el-input>
            <span style="flex-shrink: 0">~</span>
            <el-input v-model="editForm.maxAge" placeholder="最大年龄" style="flex: 1"></el-input>
            <span style="flex-shrink: 0">岁</span>
          </div>
        </el-form-item>
        <el-form-item label="结算周期" prop="settlementCycle">
          <el-select v-model="editForm.settlementCycle" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="(val, index) in settlementCycle_list"
              :label="val.label"
              :value="val.value"
              :key="'sc' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别要求" prop="gender">
          <el-select v-model="editForm.gender" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="(val, index) in gender_list"
              :label="val.label"
              :value="val.value"
              :key="'gd' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历要求" prop="educationLevel">
          <el-select v-model="editForm.educationLevel" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="(val, index) in educationLevel_list"
              :label="val.label"
              :value="val.value"
              :key="'ed' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务内容" prop="content">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="1000"
            show-word-limit
            placeholder="请填写服务内容，最多1000字"
            v-model="editForm.content"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="计费模式" prop="billMode">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="200"
            show-word-limit
            placeholder="请填写服务费计费模式，最多200字"
            v-model="editForm.billMode"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务时间" prop="serviceTime">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="100"
            show-word-limit
            placeholder="请填写提供服务的时间，最多100字"
            v-model="editForm.serviceTime"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="其他福利" prop="otherBenefits">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="100"
            show-word-limit
            placeholder="请填写可提供的其他福利，选填，最多100字"
            v-model="editForm.otherBenefits"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务地点">
          <div style="display: flex; align-items: center; gap: 8px;">
            <el-select v-model="editForm.locationVoList[0].province" placeholder="省" @change="handleEditProvinceChange(0)" style="flex: 1">
              <el-option
                v-for="(val, pIndex) in province_list"
                :label="val.name"
                :value="val.name"
                :key="pIndex"
              ></el-option>
            </el-select>
            <el-select v-model="editForm.locationVoList[0].city" placeholder="市" @change="handleEditCityChange(0)" style="flex: 1">
              <el-option
                v-for="(val, cIndex) in getEditCityOptions(0)"
                :label="val.name"
                :value="val.name"
                :key="cIndex"
              ></el-option>
            </el-select>
            <el-select v-model="editForm.locationVoList[0].district" placeholder="区" style="flex: 1">
              <el-option
                v-for="(val, dIndex) in getEditDistrictOptions(0)"
                :label="val.name"
                :value="val.name"
                :key="dIndex"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="发布时间" prop="createdAtStr">
          <el-date-picker
            v-model="editForm.createdAtStr"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发布时间"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上线状态" prop="status">
          <el-select v-model="editForm.status" placeholder="请选择" style="width: 100%">
            <el-option label="上线" :value="1"></el-option>
            <el-option label="下线" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="editLoading" @click="submitEditForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOmsTaskList, checkTask, getTaskAttachments, uploadTaskAttachment, deleteTaskAttachment, updateOmsTask, gettasksTypes, getinvoiceCategory } from '@/api/userMG';
import { china } from '@/common/area.js';

export default {
  name: 'OmsTaskList',
  data() {
    return {
      // 搜索条件
      formInline: {
        taskId: '',
        taskName: '',
        checkStatus: ''
      },
      createDateRange: [],
      // 列表数据
      listData: [],
      loading: false,
      // 分页
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 附件管理相关
      attachmentDialog: {
        visible: false,
        title: "附件管理",
      },
      previewDialog: {
        visible: false,
        url: "",
        fileName: "",
        isImage: false,
      },
      attachmentMode: "view", // view: 查看模式, upload: 上传模式
      attachmentTaskId: "",
      attachmentTaskName: "",
      attachmentList: [],
      attachmentFileList: [],
      attachmentUploading: false,
      attachmentUploadUrl: "/v1/tasks/attachment/upload",
      // 修改任务弹窗
      editDialog: {
        visible: false,
        title: "修改任务",
      },
      editLoading: false,
      editForm: {
        taskId: "",
        taskName: "",
        taskType: "",
        checkStatus: "",
        invoiceCategory: "",
        date: [],
        minCharge: "",
        maxCharge: "",
        unit: "",
        minAge: "",
        maxAge: "",
        locationVoList: [
          {
            province: "",
            city: "",
            district: "",
          },
        ],
        createdAtStr: "",
        status: "",
        merchantName: "",
        distributeCompanyName: "",
        settlementCycle: "",
        gender: "",
        educationLevel: "",
        content: "",
        billMode: "",
        serviceTime: "",
        otherBenefits: "",
      },
      editRules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" }
        ],
      },
      tasktype_list: [],
      checkStatus_list: [
        { label: "待审核", value: 0 },
        { label: "审核中", value: 1 },
        { label: "通过", value: 2 },
        { label: "驳回", value: 3 },
      ],
      unit_list: [
        { label: "日", value: 1 },
        { label: "月", value: 2 },
        { label: "小时", value: 3 },
        { label: "次", value: 4 },
        { label: "个", value: 5 },
        { label: "件", value: 6 },
      ],
      // 结算周期/性别/学历枚举与客户端编辑任务页保持一致，值域不可改动
      settlementCycle_list: [
        { label: "日结", value: 1 },
        { label: "周结", value: 2 },
        { label: "月结", value: 3 },
      ],
      gender_list: [
        { label: "男女不限", value: 0 },
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
      educationLevel_list: [
        { label: "学历不限", value: 1 },
        { label: "初中及以上", value: 2 },
        { label: "高中及以上", value: 3 },
        { label: "专科及以上", value: 4 },
        { label: "本科及以上", value: 5 },
        { label: "硕士及以上", value: 6 },
        { label: "博士", value: 7 },
      ],
      selectedCategories: [],
      categoriesOptions: [],
      province_list: [],
    };
  },
  mounted() {
    this.search();
    this.province_list = [{ name: "不限", code: "", city: [] }];
    this.province_list = this.province_list.concat(china);
    gettasksTypes().then((res) => {
      this.tasktype_list = res.data;
    });
    this.getInvoiceCategory();
  },
  methods: {
    // 搜索
    search() {
      this.pageNum = 1;
      this.loadData();
    },
    // 重置
    reset() {
      this.formInline = {
        taskId: '',
        taskName: '',
        checkStatus: ''
      };
      this.createDateRange = [];
      this.search();
    },
    // 加载数据
    loadData() {
      this.loading = true;
      const params = {
        page: this.pageNum,
        pageSize: this.pageSize,
        taskId: this.formInline.taskId,
        taskName: this.formInline.taskName,
        checkStatus: this.formInline.checkStatus,
        startDate: this.createDateRange[0] || '',
        endDate: this.createDateRange[1] || ''
      };
      getOmsTaskList(params)
        .then((res) => {
          this.listData = res.data.items || [];
          this.total = res.data.totalCount || 0;
        })
        .catch((err) => {
          console.error('加载任务列表失败:', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    // 获取审核状态类型
    getStatusType(checkStatus) {
      const typeMap = {
        0: 'warning',
        1: 'info',
        2: 'success',
        3: 'danger'
      };
      return typeMap[checkStatus] || 'info';
    },
    // 获取审核状态标签
    getStatusLabel(checkStatus) {
      const labelMap = {
        0: '待审核',
        1: '审核中',
        2: '进行中',
        3: '驳回'
      };
      return labelMap[checkStatus] || checkStatus;
    },
    // 通过任务
    approveTask(row) {
      this.$confirm('确定要**通过**该任务吗？', '通过任务', {
        confirmButtonText: '确认通过',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {
          checkTask(row.taskId, 2, '')
            .then((res) => {
              if (res.msg === 'success') {
                this.$message.success('通过成功');
                this.loadData();
              } else {
                this.$message.error(res.msg || '通过失败');
              }
            })
            .catch((err) => {
              this.$message.error('通过失败');
            });
        })
        .catch(() => {
          this.$message.info('已取消');
        });
    },
    // 驳回任务
    rejectTask(row) {
      this.$confirm('确定要驳回该任务吗？此操作将拒绝该任务的审核申请！', '驳回任务', {
        confirmButtonText: '确认驳回',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(() => {
          checkTask(row.taskId, 3, '')
            .then((res) => {
              if (res.msg === 'success') {
                this.$message.success('驳回成功');
                this.loadData();
              } else {
                this.$message.error(res.msg || '驳回失败');
              }
            })
            .catch((err) => {
              this.$message.error('驳回失败');
            });
        })
        .catch(() => {
          this.$message.info('已取消');
        });
    },
    // ========== 修改任务弹窗方法 ==========
    // 获取开票类目级联数据
    getInvoiceCategory() {
      getinvoiceCategory()
        .then((res) => {
          if (res.msg !== "success") {
            this.$message.error(res.msg || "获取开票类目失败");
            return;
          }
          this.categoriesOptions = res.data;
        })
        .catch(() => {
          this.$message.error("获取开票类目失败");
        });
    },
    // 处理开票类目选择变化
    handleInvoiceCategoryChange(value) {
      if (value && value.length === 2) {
        this.editForm.invoiceCategory = value[1];
      } else {
        this.editForm.invoiceCategory = "";
      }
    },
    // 根据已选类目反查级联选中路径
    initSelectedCategories(invoiceCategory) {
      if (!invoiceCategory || !this.categoriesOptions.length) {
        this.selectedCategories = [];
        return;
      }
      for (let parent of this.categoriesOptions) {
        if (parent.children && parent.children.length > 0) {
          for (let child of parent.children) {
            if (child.value === invoiceCategory) {
              this.selectedCategories = [parent.value, child.value];
              return;
            }
          }
        }
      }
      this.selectedCategories = [];
    },
    // 打开修改任务弹窗，行数据回显
    openEditDialog(row) {
      if (!row || !row.taskId) {
        this.$message.error("任务信息不完整");
        return;
      }
      const locationText = row.location || "";
      const locationLines = locationText ? locationText.split("\n") : [];
      // 服务地点固定单行：存量多地点只回显第一条，保存后覆盖为单条
      let firstLocation = { province: "", city: "", district: "" };
      if (locationLines.length > 0) {
        const parts = locationLines[0].split("-");
        firstLocation = { province: parts[0] || "", city: parts[1] || "", district: parts[2] || "" };
      }
      this.editForm = {
        taskId: row.taskId,
        taskName: row.taskName,
        taskType: row.taskType,
        checkStatus: row.checkStatus,
        invoiceCategory: row.invoiceCategory,
        date: [row.startTime, row.endTime],
        minCharge: row.minCharge,
        maxCharge: row.maxCharge,
        unit: row.unit,
        minAge: row.minAge,
        maxAge: row.maxAge,
        locationVoList: [firstLocation],
        createdAtStr: row.createdAt,
        status: row.status,
        merchantName: row.merchantName,
        distributeCompanyName: row.distributeCompanyName,
        settlementCycle: row.settlementCycle,
        gender: row.gender,
        educationLevel: row.educationLevel,
        content: row.content || "",
        billMode: row.billMode || "",
        serviceTime: row.serviceTime || "",
        otherBenefits: row.otherBenefits || "",
      };
      if (row.invoiceCategory) {
        this.initSelectedCategories(row.invoiceCategory);
      } else {
        this.selectedCategories = [];
      }
      this.editDialog.visible = true;
    },
    // 当前编辑行的市选项（按省名查）
    getEditCityOptions(index) {
      const row = this.editForm.locationVoList[index];
      if (!row || !row.province) {
        return [];
      }
      if (row.province === "不限") {
        return [{ name: "不限", code: "", area: [] }];
      }
      const province = this.province_list.find((item) => item.name === row.province);
      return province ? province.city || [] : [];
    },
    // 当前编辑行的区选项（按市名查）
    getEditDistrictOptions(index) {
      const row = this.editForm.locationVoList[index];
      if (!row || !row.city) {
        return [];
      }
      if (row.city === "不限") {
        return [{ name: "不限", code: "" }];
      }
      const city = this.getEditCityOptions(index).find((item) => item.name === row.city);
      return city ? city.area || [] : [];
    },
    // 省变化后重置该行的市区
    handleEditProvinceChange(index) {
      const row = this.editForm.locationVoList[index];
      if (!row) return;
      row.city = row.province === "不限" ? "不限" : "";
      row.district = row.province === "不限" ? "不限" : "";
    },
    // 市变化后重置该行的区
    handleEditCityChange(index) {
      const row = this.editForm.locationVoList[index];
      if (!row) return;
      row.district = row.city === "不限" ? "不限" : "";
    },
    // 保存修改任务
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        // 文本字段字数兜底校验：超限提示且不发起请求
        const textLimits = [
          { key: "content", label: "服务内容", limit: 1000 },
          { key: "billMode", label: "计费模式", limit: 200 },
          { key: "serviceTime", label: "服务时间", limit: 100 },
          { key: "otherBenefits", label: "其他福利", limit: 100 },
        ];
        for (const item of textLimits) {
          const val = this.editForm[item.key] || "";
          if (val.length > item.limit) {
            this.$message.error(item.label + "不能超过" + item.limit + "字");
            return;
          }
        }
        // 空地点行不提交，全部为空则不更新服务地点
        const locationVoList = this.editForm.locationVoList.filter(
          (row) => row.province || row.city || row.district
        );
        const params = {
          taskName: this.editForm.taskName,
          taskType: this.editForm.taskType,
          checkStatus: this.editForm.checkStatus,
          invoiceCategory: this.editForm.invoiceCategory,
          startTime: this.editForm.date ? this.editForm.date[0] : "",
          endTime: this.editForm.date ? this.editForm.date[1] : "",
          minCharge: this.editForm.minCharge,
          maxCharge: this.editForm.maxCharge,
          unit: this.editForm.unit,
          minAge: this.editForm.minAge,
          maxAge: this.editForm.maxAge,
          locationVoList: locationVoList,
          createdAt: this.editForm.createdAtStr,
          status: this.editForm.status,
          settlementCycle: this.editForm.settlementCycle,
          gender: this.editForm.gender,
          educationLevel: this.editForm.educationLevel,
          content: this.editForm.content,
          billMode: this.editForm.billMode,
          serviceTime: this.editForm.serviceTime,
          otherBenefits: this.editForm.otherBenefits,
        };
        // 空字符串统一转 null，避免后端数字/枚举字段反序列化报错，空值字段保持原值不更新
        Object.keys(params).forEach((key) => {
          if (params[key] === "") {
            params[key] = null;
          }
        });
        this.editLoading = true;
        updateOmsTask(this.editForm.taskId, params)
          .then((res) => {
            this.editLoading = false;
            if (res.msg === 'success') {
              this.editDialog.visible = false;
              this.$message.success('修改成功');
              this.loadData();
            } else {
              this.$message.error(res.msg || '修改失败');
            }
          })
          .catch(() => {
            this.editLoading = false;
            this.$message.error('修改失败');
          });
      });
    },
    // ========== 修改任务弹窗方法结束 ==========
    // 双击复制
    copyToClipboard(text) {
      if (!text) return;
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制');
    },
    // 格式化时间
    formatDateTime(timestamp) {
      if (!timestamp) return '-';
      const timestampMs = timestamp.toString().length <= 10 ? timestamp * 1000 : timestamp;
      const date = new Date(timestampMs);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    // ========== 附件管理方法 ==========
    // 打开附件管理弹窗
    openAttachmentDialog(row, mode = "view") {
      if (!row || !row.taskId) {
        this.$message.error("任务信息不完整");
        return;
      }
      this.attachmentTaskId = row.taskId;
      this.attachmentTaskName = row.taskName;
      this.attachmentMode = mode;
      this.attachmentDialog.title = mode === "view" 
        ? `查看附件 - ${row.taskName}` 
        : `上传附件 - ${row.taskName}`;
      this.attachmentFileList = [];
      this.attachmentDialog.visible = true;
      if (mode === "view") {
        this.loadAttachmentList();
      }
    },
    // 关闭附件管理弹窗
    closeAttachmentDialog() {
      this.attachmentDialog.visible = false;
      this.attachmentTaskId = "";
      this.attachmentTaskName = "";
      this.attachmentList = [];
      this.attachmentFileList = [];
    },
    // 格式化文件大小（字节转可读格式）
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
    // 加载附件列表
    loadAttachmentList() {
      if (!this.attachmentTaskId) return;
      getTaskAttachments(this.attachmentTaskId)
        .then((res) => {
          if (res.msg === "success") {
            this.attachmentList = res.data || [];
          } else {
            this.$message.error(res.msg || "获取附件列表失败");
          }
        })
        .catch((err) => {
          this.$message.error("获取附件列表失败");
        });
    },
    // 处理文件选择变化
    handleAttachmentChange(file, fileList) {
      this.attachmentFileList = fileList;
    },
    // 处理文件移除
    handleAttachmentRemove(file, fileList) {
      this.attachmentFileList = fileList;
    },
    // 处理文件数量超限
    handleAttachmentExceed(files, fileList) {
      this.$message.warning(`最多只能上传10个文件`);
    },
    // 提交附件上传
    submitAttachmentUpload() {
      if (this.attachmentFileList.length === 0) {
        this.$message.warning("请选择要上传的文件");
        return;
      }
      this.attachmentUploading = true;
      const formData = new FormData();
      this.attachmentFileList.forEach((file) => {
        if (file.raw) {
          formData.append("files", file.raw);
        }
      });
      uploadTaskAttachment(this.attachmentTaskId, formData)
        .then((res) => {
          this.attachmentUploading = false;
          if (res.msg === "success") {
            this.$message.success("上传成功");
            this.attachmentFileList = [];
            this.loadAttachmentList();
          } else {
            this.$message.error(res.msg || "上传失败");
          }
        })
        .catch((err) => {
          this.attachmentUploading = false;
          this.$message.error("上传失败");
        });
    },
    // 判断是否为图片
    isImage(row) {
      if (!row.fileExtension) return false;
      const ext = row.fileExtension.replace(/^\./, '').toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
    },
    // 判断是否为视频
    isVideo(row) {
      if (!row.fileExtension) return false;
      const ext = row.fileExtension.replace(/^\./, '').toLowerCase();
      return ['mp4', 'webm', 'ogg'].includes(ext);
    },
    // 判断是否可预览（图片和视频）
    isPreviewable(row) {
      return this.isImage(row) || this.isVideo(row);
    },
    // 预览附件
    previewAttachment(row) {
      const fileUrl = row.fileUrl;
      this.previewDialog.url = fileUrl;
      this.previewDialog.fileName = row.fileName;
      const ext = row.fileExtension.replace(/^\./, '').toLowerCase();
      this.previewDialog.isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
      this.previewDialog.visible = true;
    },
    // 下载附件（使用minio返回的fileUrl）
    downloadAttachment(row) {
      if (!row.fileUrl) return;
      window.open(row.fileUrl);
    },
    // 删除附件
    deleteAttachment(row) {
      this.$confirm("确定要删除该附件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTaskAttachment(row.attachmentId)
            .then((res) => {
              if (res.msg === "success") {
                this.$message.success("删除成功");
                this.loadAttachmentList();
              } else {
                this.$message.error(res.msg || "删除失败");
              }
            })
            .catch((err) => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // ========== 附件管理方法结束 ==========
  }
};
</script>

<style scoped>
.oms-task-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-breadcrumb {
  margin-bottom: 16px;
}

.search-section {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.search-input {
  width: 180px;
}

.search-date-picker {
  width: 320px;
}

.table-card {
  margin-bottom: 0;
}

/* 操作列按钮强制同行显示 */
.table-card >>> .op-col .cell {
  white-space: nowrap;
}

.pagination {
  margin-top: 16px;
  text-align: left;
}

/* 附件预览样式 */
.attachment-preview {
  cursor: pointer;
  display: inline-block;
}

.attachment-thumbnail {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/oms/taskList.vue